export const LOGOUT_USER = 'parcel/logout/LOGOUT_USER';
